import * as React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useLocation, useNavigate } from 'react-router-dom';
import CampaignCrm from './component/campaignCrm';
import ContactsCrm from './component/contactsCrm';
import PopulationCrm from './component/populationCrm';
import Iconify from '../../components/Iconify';
import CanalVente from '../communication/canal_de_vente/CanalDeVente';
import Dashboard from './component/dashboard';
import Parameter from './component/parameter';
import FAQ from './component/faq';
import Tutoriels from './component/tutoriel';
import Article from './component/article';

export default function ResourceTab() {
  const [value, setValue] = React.useState('1');
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === '1') {      
        navigate(`/resource/faqs`);
    }
    if (newValue === '2') {
      if (!pathname.includes('articles')) {
        navigate(`/resource/articles`);
      }

    }
    else if (newValue === '3') {
      if (!pathname.includes('tutoriels')) {
        navigate(`/resource/tutoriels`);
      }
    }
  };

  React.useEffect(() => {
    (async () => {
      try {
        const tmp = pathname.split('/')
        console.log(tmp)
        if (tmp[tmp.length - 1] === 'articles') {
          navigate(`/resource/articles`, { replace: true });
          setValue('2')
        } 
        else if (tmp[tmp.length - 1] === 'faqs') {
          navigate(`/resource/faqs`, { replace: true });
          setValue('1')
        } else if (tmp[tmp.length - 1] === 'tutoriels') {
          navigate(`/resource/tutoriels`, { replace: true });
          setValue('3')
        }
      } catch (error) {
        console.log('error');
      }

    })();
  }, []);


  return (
    <Box sx={{ width: '100%',  typography: 'body1' }}>
      <TabContext value={value}>
        <Box sx={{
          paddingX: {xs:0, sm: 5}, position: 'sticky',
          top: 0,
          zIndex: 1,
          backgroundColor: '#f2f2f2'
        }}>
          <TabList variant="scrollable" allowScrollButtonsMobile  sx={{ indicatorColor: '#5E17EB' }} onChange={handleChange} aria-label="lab API tabs example">
            <Tab label="FAQ" value="1" />
            <Tab label="Article" value="2" />
            <Tab label="Tutoriels" value="3" />
          </TabList>
        </Box>
        <Box sx={{ height: 'calc(100vh - 143px)', overflowY: 'auto' }}>
          <TabPanel sx={{ paddingX: { xs: 0, sm: 3 } }} value="1">
            <FAQ />
          </TabPanel>
          <TabPanel sx={{ paddingX: { xs: 0, sm: 3 } }} value="2">
            <Article />
          </TabPanel>
          <TabPanel sx={{ paddingX: { xs: 0, sm: 3 } }} value="3">
            <Tutoriels />
          </TabPanel>
        </Box>
      </TabContext>
    </Box>
  );
}